// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ThresholdIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ThresholdIcon" ref={forwardedRef} {...props}>
      <path d="M14.497 6.338c.1-1.131.73-1.44 1.082-1.433.313.006.921.291.921 1.53H18c0-1.787-1.017-3.002-2.391-3.03-1.335-.027-2.453 1.093-2.605 2.795l-.69 6.583a.25.25 0 0 1-.147.202l-1.204.535c-.577.257-.88.792-1.044 1.095a.97.97 0 0 1-.872.48c-.27-.016-.634-.174-.82-.843L6.73 7.758 6.727 7.75c-.148-.577-.38-1.056-.725-1.43A2.56 2.56 0 0 0 4.787 5.6C4.356 5.478 3.893 5.442 3.44 5.431a28 28 0 0 0-.906 0L2 5.436v1.5q.317-.001.59-.004a24 24 0 0 1 .815 0c.412.01.726.042.975.112a1.07 1.07 0 0 1 .522.297c.13.14.265.37.37.772l1.5 6.505.004.014c.334 1.234 1.202 1.904 2.187 1.96a2.46 2.46 0 0 0 2.275-1.262 2 2 0 0 1 .207-.327.4.4 0 0 1 .127-.112l1.204-.535a1.75 1.75 0 0 0 1.03-1.417l.69-6.589z" />
      <path d="M8.298 9h3.156l-.184 1.75H8.702z" />
      <path d="m4.193 9 .404 1.75H2V9z" />
      <path d="m15.475 9-.183 1.75H18V9z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ThresholdIcon = /* @__PURE__ */ Object.assign(
  ThresholdIconComponent,
  { displayName: 'ThresholdIcon' },
);
